const JobsData = [
    {
        id: 1,
        title: "Senior Civil Engineer",
        location: "Choice- New Weija, Accra",
        deadline: "27th February, 2026",
        email: "prixincomltd@gmail.com",
        description: "We are looking for an experienced Senior Civil Engineer to lead and supervise civil works on site, ensuring compliance with regulations and safety standards.",
        responsibilities: [
            "Lead and supervise civil works on site",
            "Ensure compliance with regulations and safety standards",
            "Provide technical expertise on design, construction and maintenance",
            "Coordinate site activities with project managers and site teams",
            "Conduct site inspections and quality control checks"
        ],
        requirements: [
            "Bachelor’s Degree in Civil Engineering",
            "Minimum of 8-10 years of civil engineering experience",
            "Membership with a recognized professional body (eg. GhIE)",
            "Additional training in contract administration & construction management",
            "Leadership & team coordination skills",
            "Site supervision & project management skills"
        ]
    },
    {
        id: 2,
        title: "Senior Quantity Surveyor",
        location: "Choice- New Weija, Accra",
        deadline: "27th February, 2026",
        email: "prixincomltd@gmail.com",
        description: "We are seeking a Senior Quantity Surveyor to manage cost planning, budgeting, cost control and cash flow throughout the project lifecycle.",
        responsibilities: [
            "Manage cost planning, budgeting, cost control and cash flow throughout the project lifecycle",
            "Prepare and review valuations, payments and final accounts",
            "Administer contracts and handle variations/claims",
            "Support procurement including subcontractor negotiations",
            "Monitor expenditures and prepare cost reports",
            "Coordinate with project teams and guide junior quantity surveyors"
        ],
        requirements: [
            "Bachelor’s Degree in Quantity Surveying, Civil Engineering or a related discipline",
            "Minimum of 8-10 years of quantity surveying experience",
            "Membership with a recognized professional body (eg. RICS or equivalent)",
            "Proven experience on civil works projects (infrastructure, roads, utilities & earthworks)",
            "Strong knowledge of civil construction contracts and commercial practices",
            "Effective communication and stakeholder management abilities",
            "Strong analytical, negotiation and problem-solving skills"
        ]
    },
    {
        id: 3,
        title: "Construction Bulldozer & Excavator Operators",
        location: "Choice- New Weija, Accra",
        deadline: "8th March, 2026",
        email: "prixincomltd@gmail.com",
        description: "Seeking passionate individuals to explore exciting job opportunities and join a successful, growing family. Prixin Company Limited is hiring Construction Bulldozer & Excavator Operators.",
        responsibilities: [
            "Operate bulldozers and/or excavators efficiently and safely on construction sites",
            "Perform daily pre-operation inspections",
            "Execute earthmoving, grading, trenching, and site clearing activities as required",
            "Follow instructions from Site Supervisor and Project Manager",
            "Maintain equipment cleanliness and report mechanical faults immediately",
            "Ensure compliance with all health and safety regulations",
            "Work collaboratively with site team members to meet project deadlines"
        ],
        requirements: [
            "Minimum 3-5 years experience operating heavy machinery (Bulldozer & Excavator) on construction sites",
            "Experience in civil works, road construction, building projects, or infrastructure development",
            "Valid driver’s license Class E",
            "Ability to perform daily machine inspection",
            "Knowledge of safety procedures",
            "Ability to work on construction sites"
        ]
    }
];

export default JobsData;
